<template>
  <section class="mb-0 py-0 min-h-svh md:mb-[-100svh] overflow-x-hidden px-2 sm:padding-x">
    <div
      id="hero"
      class="relative flex flex-col w-full pb-0 pt-16 sm:pt-32 min-h-svh md:sticky md:top-0 md:min-h-svh md:flex md:items-end md:pt-14 md:pb-4"
    >
      <div class="relative flex w-full flex-grow flex-col items-center justify-between md:min-h-0 md:justify-start md:flex-none">
        
        <!-- TOP -->
        <div class="w-full items-end overflow-clip">
          <div class="flex w-full items-start gap-6 sm:gap-10 lg:gap-10 pt-10 sm:pt-0">
            <MyName />
            <Star id="star" class="hide-on-mobile translate-x-full" />
          </div>
        </div>

        <!-- GRID -->
        <div class="lg:column-gap md:pt-0 grid w-full flex-grow grid-cols-12 gap-y-4 md:gap-y-0 items-end px-0 sm:px-0">
          
          <div
            class="col-span-full flex flex-col items-start gap-6 sm:col-span-4 sm:gap-14 md:gap-6 md:mb-10"
          >
            <div class="overflow-hidden">
              <svg
                id="down-arrow"
                stroke="currentColor"
                fill="none"
                stroke-width="1.25"
                viewBox="6 6 12 12"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="hide-on-mobile m-0 size-4 -translate-x-full p-0 md:size-6"
                color="#8C8C73"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="7" y1="7" x2="17" y2="17"></line>
                <polyline points="17 7 17 17 7 17"></polyline>
              </svg>
            </div>

            <p class="sr-only">
              A freelance UI/UX-Designer, cutting-edge technologies to
              deliver comprehensive solutions for your business.
            </p>

            <p
              v-html="whoAmI"
              id="whoAmI"
              class="who-am-i heading-5 w-full max-w-[40ch] overflow-clip leading-snug font-medium text-start mt-8 sm:max-w-[37ch] md:mt-0 lg:mt-0"
            ></p>

            <div class="relative origin-left sm:scale-150">
              <div id="contact-btn" class="flex mt-0 md:mt-1">
                <Button
                  label="Get in touch"
                  url="mailto:hello@draftex.in"
                  class="bg-gradient-to-r from-[#CE2906] via-[#E04A20] to-[#FF7B00] text-white border-none"
                />
              </div>
            </div>
          </div>

          <div
            id="profile-container"
            class="relative col-span-6 sm:col-span-4 flex flex-col rounded-[8px] overflow-hidden select-none mt-2 sm:mt-0 md:flex md:h-auto md:mt-12 md:ml-12 sm:-ml-8"
          >
            <img
              id="profile-img"
              :src="logo"
              alt="logo"
              class="max-h-[40vh] sm:max-h-[55vh] w-full rounded-[8px] object-cover"
            />
          </div>

          <!-- RIGHT CONTENT -->
          <div
            class="relative col-span-6 sm:col-span-4 size-full overflow-hidden text-start pl-2 sm:pl-0 mt-2 sm:mt-0 sm:text-end flex items-end"
          >
            <div
              id="available-for-work"
              class="relative right-0 bottom-0 flex flex-col items-start sm:absolute sm:translate-y-full sm:items-end"
            >
                <p
                  class="text-[10px] sm:text-base block leading-tight font-medium -tracking-tight uppercase"
                >
                  Design with Purpose, Work with Empathy.
                </p>

                <h3
                  class="font-fancy block leading-none font-bold -tracking-tight
                         text-base sm:text-xl md:text-2xl"
                >
                  Thoughtful UI, Meaningful UX.
                </h3>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- SCROLL SPACE -->
    <div class="hidden md:block h-svh"></div>
  </section>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { MyName, Star } from '../design';
import { Button } from '@/components/common';
import logo from '@/assets/images/logo.webp';
import { getAvailableForWorkDate, textSplitterIntoChar } from '@/functions';

const whoAmI = ref(
  'DRAFTEX is a modern, AI-powered design and digital solutions agency that transforms ideas into impactful digital experiences, delivering innovative, scalable, and result-driven solutions for businesses.'
);

const AvailableForWorkDate = ref('');

onBeforeMount(() => {
  whoAmI.value = textSplitterIntoChar(whoAmI.value);
  AvailableForWorkDate.value = getAvailableForWorkDate();
});
</script>